"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
let HealthService = class HealthService {
    healthCheck() {
        return { status: 'ok' };
    }
};
exports.HealthService = HealthService;
exports.HealthService = HealthService = tslib_1.__decorate([
    (0, common_1.Injectable)()
], HealthService);
